/**
 * Created by ccczzz on 2020/7/15.
 */
import  TopMenu from '../../../components/RigtTopMenu'
import  Bottom from '../../../components/Bottom'
export default{
    data(){
        return {
            currentIndex:'0',
        }
    },
    mounted(){
        var index=sessionStorage.getItem('currentIndex')
        var login=sessionStorage.getItem('logined');
        //如果当前选择的是常见问题跳转常见问题  如果选择的是其他页面并且没有登录 则跳转登录页面
        //防止用户在浏览器直接输入地址进入后续页面
        if(index=='3'){
            var currentIndex=index;
            this.currentIndex=currentIndex;
        }else if(!login||login!='1'){
            sessionStorage.setItem('logined','0');
            sessionStorage.setItem('token','');
            this.$router.replace('/login');
        }else{
            sessionStorage.setItem('logined','1');
        }
    },
    components: {
        TopMenu,
        Bottom,
    },
    methods: {
        getSelectIndex:function (index) {
            this.currentIndex=index;
        },
    }
}


